<script>
import MenuItem from '@/components/menu/MenuItem'

import { MY_MENU_QUERY } from '@/graph/gql/product.gql'
import { GET_VIEWER_SHORT_QUERY } from '@/graph/gql/user.gql'
import { deleteProduct } from '@/graph/mutations/product'

export default {
  name: 'MenuView',
  components: { MenuItem },
  apollo: {
    myMenu: {
      query: MY_MENU_QUERY,
      fetchPolicy: 'cache-and-network'
    },
    user: {
      query: GET_VIEWER_SHORT_QUERY,
      update: data => data.viewer
    }
  },
  data() {
    return {
      myMenu: [],

      deleteDialog: false,
      deleteItem: {}
    }
  },
  methods: {
    openDeleteDialog(product) {
      this.deleteDialog = true
      this.deleteItem = product
    },

    closeDeleteDialog() {
      this.deleteDialog = false
      this.deleteItem = {}
    },

    deleteProduct() {
      const { id } = this.deleteItem
      if (!id) return

      // TODO: add error handling
      deleteProduct(id)
        .then(() => {
          this.$toast('Item was removed from your menu')

          // Remove product from state
          this.myMenu = this.myMenu.filter(x => x.id !== id)
        })
        .catch(err => console.log(err))
        .finally(this.closeDeleteDialog)
    }
  }
}
</script>

<template>
  <transition name="slide-up" appear>
    <!-- Menu view page -->
    <div class="view-grid">
      <div>
        <h1 v-if="user" class="display-1 font-weight-bold mb-3">
          {{ user.firstName }}’s menu
        </h1>

        <div>
          <v-skeleton-loader
            :loading="!myMenu.length && $apollo.loading"
            transition="fade-transition"
            height="94"
            type="list-item-avatar-two-line"
          >
            <div v-if="myMenu">
              <!-- Products list -->
              <div v-if="myMenu.length" class="mt-3">
                <MenuItem
                  v-for="product in myMenu"
                  :key="product.id"
                  :product="product"
                  @delete="openDeleteDialog"
                />
              </div>

              <div v-else class="menu-empty pb-2">
                <div class="subtitle-1 font-weight-bold">
                  Add your first dish
                </div>
                <div class="body-2">
                  Don't worry, it won't go up for sale <br />
                  until you say you're ready.
                </div>
              </div>

              <!-- Add new -->
              <div class="text-center my-4">
                <v-btn
                  :to="{ name: 'MenuItemView', params: { id: 'new' } }"
                  rounded
                  :outlined="!!myMenu.length"
                  color="primary"
                >
                  <v-icon left size="16">$vuetify.icons.add</v-icon> Add menu
                  item
                </v-btn>
              </div>
            </div>
          </v-skeleton-loader>
        </div>

        <!-- Delete dialog -->
        <v-dialog v-model="deleteDialog" max-width="500px">
          <v-card>
            <v-card-title>Remove menu item?</v-card-title>

            <v-card-text>
              This will remove <b>{{ deleteItem.name }}</b> from your menu and
              Pona users won't be able to order it. Upcoming pickups won't be
              affected.
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                color="blue-grey darken-1"
                text
                @click="closeDeleteDialog()"
              >
                Cancel
              </v-btn>
              <v-btn color="pink darken-1" text @click="deleteProduct()">
                Remove
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </transition>
</template>

<style lang="sass" scoped>
h1
  font-size: 28px

.v-btn--outlined
  border-color: #aaa
</style>

<style lang="sass">
.menu-empty
  text-align: center
  margin-top: 45%
</style>
